export default __webpack_public_path__ + "static/media/property_240.9e5caa4b.png";